import { BannerResponse } from "../types/BannerResponse";
import axiosInstance, { chooseApi } from "./axiosInstance";

class ProductService {
  static async getProductById(
    id: number,
  ): Promise<ProductDetailResponse | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<ProductDetailResponse>
      >(`/products/${id}`);

      return Promise.resolve(response.data.result);
    } catch (error) {
      throw error;
    }
  }
  static async getProductBySlug(
    slug: string,
  ): Promise<ProductDetailResponse | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<ProductDetailResponse>
      >(`/products/slug/${slug}`);

      return Promise.resolve(response.data.result);
    } catch (error) {
      throw error;
    }
  }

  static async getProductsList(
    params: any,
  ): Promise<PageResult<ProductDetailResponse>> {
    const response = await axiosInstance.get<
      ApiResponse<PageResult<ProductDetailResponse>>
    >(`/products`, {
      params,
    });
    return response.data.result;
  }
  static async getMusicalTicketInfo(id: string): Promise<any | undefined> {
    try {
      const response = await axiosInstance.get<ApiResponse<ExtProductDTO>>(
        `/products/musical/${id}`,
      );
      return Promise.resolve(response.data.result);
    } catch (error) {
      throw error;
    }
  }

  static convertBookingInfo = (bookingInfo: BookingInfo): any => {
    return;
  };
  static async getAttributeActive(
    bookingInfo: BookingInfo,
  ): Promise<number[] | undefined> {
    const param = {
      productId: bookingInfo?.productId,
      qtyAdult: bookingInfo?.qtyAdult,
      qtyChild: bookingInfo?.qtyChild,
      qtyRoom: bookingInfo?.qtyRoom,
      qtyVehicle: bookingInfo?.qtyVehicle,
      ageNumbers: bookingInfo?.ageNumbers,
      additional: bookingInfo?.additional?.id,
      luggage: bookingInfo?.luggage?.id,
      pickUpAirport: bookingInfo?.pickUpAirport?.id,
      ticketType: bookingInfo?.ticketType?.id,
    };
    try {
      const response = await axiosInstance.post<ApiResponse<number[]>>(
        `products/active`,
        param,
      );

      // return response.data?.result;
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }

  static async getProducts(
    pageSize: number,
    pageIndex: number,
    keyword: string,
    productType: string,
  ): Promise<PageResult<ProductBaseResponse> | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<ProductBaseResponse>>
      >(`products/${productType}`, {
        params: {
          pageSize,
          pageIndex,
          keyword,
        },
      });
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getRecommend(
    pageSize: number,
    pageIndex: number,
    keyword: string,
  ): Promise<RecommendResponseDTO | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<RecommendResponseDTO>
      >(`products/recommend`, {
        params: {
          pageSize,
          pageIndex,
          keyword,
        },
      });
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getWishList(
    productIds: number[],
  ): Promise<ProductBaseResponse[]> {
    try {
      const response = await axiosInstance.post<
        ApiResponse<ProductBaseResponse[]>
      >(`products/wishlist`, productIds);
      return response.data?.result;
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  }

  static async getPrice(request?: BookingInfo): Promise<any | undefined> {
    try {
      if (!request) return;
      const response = await axiosInstance.post<ApiResponse<any>>(
        `/products/price`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async syncCart(request?: BookingInfo): Promise<any | undefined> {
    try {
      if (!request) return;
      const response = await axiosInstance.post<ApiResponse<any>>(
        `/cart/sync`,
        request,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getProductCity(
    cityId: number,
    type?: string,
  ): Promise<{ product: ProductBaseResponse[] }> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<{ product: ProductBaseResponse[] }>
      >(`/products/popular`, {
        params: {
          city: cityId,
          type,
        },
      });

      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
  static async getBanner(props?: { type?: string }): Promise<BannerResponse> {
    try {
      const response = await chooseApi().get<ApiResponse<BannerResponse>>(
        `/banners`,
        {
          params: {
            type: props?.type,
          },
        },
      );

      return response.data.result;
    } catch (error) {
      throw error;
    }
  }

  static async fetchProductList(params: {
    city?: string;
    category?: string;
    subCategory?: string;
    keyword?: string;
    type?: string;
    excludeIds?: string;
    commonSort?: string;
  }): Promise<PageResult<ProductDetailResponse> | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<ProductDetailResponse>>
      >(`/products/list`, {
        params,
      });
      return response.data.result;
    } catch (error) {}
  }
  static async fetchProductList2(params: {
    city?: string;
    category?: string;
    subCategory?: string;
    keyword?: string;
    type?: string;
    excludeIds?: string;
    commonSort?: string;
    pageSize?: number;
    pageIndex?: number;
  }): Promise<PageResult<ProductDetailResponse> | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<ProductDetailResponse>>
      >(`/products/list`, {
        params,
      });
      return response.data.result;
    } catch (error) {}
  }
  static async getTicketByPass(params: {
    id: number;
    pageIndex: number;
    pageSize: number;
    productType?: string;
    categoryId?: number | null;
  }): Promise<PageResult<ProductOfPassDTO> | undefined> {
    try {
      const response = await axiosInstance.get<
        ApiResponse<PageResult<ProductOfPassDTO>>
      >(`/products/pass`, {
        params,
      });
      return response.data.result;
    } catch (error) {}
  }
  static async get3rdProductAvailability(params: {
    productId: number;
    month: string;
    quantity: number;
    bookingId?: string;
  }): Promise<TCalendarConfig[] | undefined> {
    try {
      const response = await axiosInstance.get<ApiResponse<TCalendarConfig[]>>(
        `/products/3rd/availability`,
        {
          params,
        },
      );
      return response.data.result;
    } catch (error) {}
  }
  static async getProductAvailability(params: {
    productId: number;
    month: string;
  }): Promise<TCalendarConfig[] | undefined> {
    try {
      const response = await axiosInstance.get<ApiResponse<TCalendarConfig[]>>(
        `/products/${params.productId}/availability`,
        {
          params,
        },
      );
      return response.data.result;
    } catch (error) {}
  }
}

export default ProductService;

export const updateOrderNoOfProduct = async (
  orderingKey: string,
  request: {
    ids: number[];
    orderNos?: number[];
    offset: number;
  },
) => {
  const response = await axiosInstance.request({
    method: "post",
    url: "/orderings/orderNo?orderingKey=" + orderingKey,
    data: request,
  });
  return response.data.result;
};

export const updateOrderNoOfProductPass = async (request: {
  ids: number[];
  orderNos?: number[];
  // offset: number;
}) => {
  const response = await axiosInstance.request({
    method: "post",
    url: "/products/pass/orderNo",
    data: request,
  });
  return response.data.result;
};
